module.exports = __webpack_public_path__ + "media/images/emblems/Breitenbach-blason-a9413ebccd626600e06366e53344a6e3.png";